// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuetify from 'vuetify';
import Datetime from 'vue-datetime';
import Resource from 'vue-resource';
import Cookie from 'vue-cookie';
import Lang from 'vuejs-localization';
import VueClipboard from 'vue-clipboard2'

import App from './App';
import router from './router';
import Item from './components/catalog/Item';
import Auth from './auth';

Vue.config.productionTip = false;
//Date and Time Picker
import 'vue-datetime/dist/vue-datetime.css';
Vue.use(Datetime);
//Vuetify
import 'vuetify/dist/vuetify.min.css';
import colors from 'vuetify/es5/util/colors'
Vue.use(Vuetify, {
  theme: {
    primary: colors.amber.darken1,
    secondary: colors.grey.darken3,
    accent: colors.amber.accent1,
    error: colors.deepOrange.darken1,
  },
});

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

// Vue resource
Vue.use(Resource);
Vue.http.options.root = process.env.NODE_ENV === 'production' ? '/sunbackend' : '/api/sunbackend';

// Vue cookie
Vue.use(Cookie);

// Vue localization
Lang.requireAll(require.context('./lang', true, /\.js$/));
Vue.use(Lang);

Vue.use(Auth);
// Register global components
Vue.component('item', Item);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js